// list of states that will see Harisumiran Sunday Sabha option when assigning sabha
export const ALLOWED_STATES_HARISUMIRAN_SUNDAY_SABHA = ['nj', 'ny', 'pa'];
